<template>
  <div class="bodys" v-if="body_show">
    <div class="top_v" v-if="!info.same">
      <img :src="shareUserinfo.headimgurl" alt="" />我已入营，邀请你一起加速职业发展
    </div>
    <div class="top">
      <img :src="info.cover" alt="" class="top_m" />
      <span>{{info.count}} 人已购买</span>
      <!-- <div class="top_b clearfix">
        <div class="tb_l">
          <h2>课程原价 {{info.price}} 元</h2>
          <h3>限时拼团优惠价 {{info.missionPrice}} 元</h3>
          <h4>{{info.count}}人已购买</h4>
        </div>
        <div class="tb_r">
          <router-link :to="'/invitation_progress?course_id=' + course_id + '&urlfrom=' + shimo_url">
            <div class="red-envelope">
              <div class="red-envelope-text">
                <small class="red-num">{{info.first_fee}}</small>元
              </div>
            </div>
            <span>我要<br/>推广</span>
          </router-link>
        </div>
      </div> -->
    </div>
    <div class="content">
      <div  :class="['tar_img',!info.same?'tar_imgs':'']" v-html="info.detail"></div>
      <!-- 7天的职业定位训练营原价199元，拼团仅需9.9元-->
      <h3 class="on-money">{{info.name}}<br/>原价{{info.price}}元，<span>拼团仅需{{info.missionPrice}}元</span></h3>
    </div>
    <!-- <div :class="['tar_img',!info.same?'tar_imgs':'']">
      <img src="@a/training1.png" alt="" />
      <img src="@a/training2.png" alt="" />
      <img src="@a/training3.png" alt="" />
      <img src="@a/training4.png" alt="" />
      <img src="@a/training5.png" alt="" />
      <img src="@a/training6.png" alt="" />
      <img src="@a/training7.png" alt="" />
      <img src="@a/training8.png" alt="" />
      <img src="@a/training9.png" alt="" />
      <img src="@a/training10.png" alt="" />
      <img src="@a/training11.png" alt="" />
      <img src="@a/training12.png" alt="" />
      <img src="@a/training13.png" alt="" />
      <img src="@a/training14.png" alt="" />
    </div> -->
    <div class="learning-instructions">
      <h3>学习须知</h3>
      <div class="instructions-content">
        <p>1. 拼团成功后或通过好友邀请报名，即可查看班主任微信</p>
        <p>2. 申请添加班主任会在48小时内通过，请耐心等待哦。</p>
        <p>3. 报名后班主任会跟进排期安排最近期次入学。</p>
      </div>
    </div>
    <!--  -->
    <div class="banq">
      * 本训练营由新精英生涯（北京）教育科技有限公司版权所有，违者必究
    </div>
    <div class="foot clearfix">
      <a class="foot_l" @click="signHandle('common',0)">
        单独购买
        <br/>¥{{info.price}}
      </a>
      <div class="foot_r">
        <router-link :to="'/details_spell?course_id='+ course_id + '&share='+ share + '&source=' + source + '&urlfrom=' + shimo_url_group">
          发起拼团
          <br/>¥{{info.missionPrice}}
        </router-link>
      </div>
    </div>
    <public-mobile ref="handle" :train_pay="train_pay"></public-mobile>
  </div>
</template>
<script>
import {
  seven_index
} from "@/api/training";
import {
  shareCon
} from "@/utils/wxconfig";
export default {
  data() {
      return {
        body_show: false,
        course_id: '',
        share: '',
        source: '',
        info: {},
        user: {},
        mission: {},
        shareUserinfo: {},
        train_pay: {},
        type_obj: {},
        shimo_url: '',
        shimo_url_group: ''
      };
    },
    methods: {
      // 付款
      signHandle(type, mission_type) {
        this.train_pay = {
          share: this.share, //分享人ID
          source: this.source || '', //分享来源
          mission_id: this.mission.mission_id, //拼团ID
          mission_type: mission_type, //拼团状态0单独购买1创建拼团2参团
          type: type,
          course_id: this.course_id
        };
        setTimeout(() => {
          this.$refs.handle.pay_training();
        }, 200)

      },
      pullData() {
        this.course_id = this.$route.query.course_id;
        this.share = this.$route.query.share || 0;
        if(this.$route.query.source) {
          this.source = typeof this.$route.query.source == 'string' ? this.$route.query.source:this.$route.query.source[0];
        }
        this.$toast.loading({
          mask: true,
          message: "加载中..."
        });
        seven_index({
            course_id: this.course_id,
            share: this.share
          })
          .then(data => {

            this.body_show = true;
            this.$toast.clear();
            document.title = data.info.name;
            this.info = data.info;
            this.user = data.user;
            this.mission = data.mission;
            this.share = data.mission.share;
            this.shareUserinfo = data.shareUserinfo;
            this.shimo_url = this.info.same ? 'index_start_red' : 'index_friend_red';
            this.shimo_url_group = this.info.same ? 'index_start_group' : 'index_friend_group';
            if (data.mission.mission) {
              this.$router.push({
                path: '/details_index',
                query: {
                  course_id: this.course_id,
                  share: this.share,
                  mission_id: data.mission.mission_id
                }
              })
            } else {
              if (data.info.buy) {
                this.$router.push({
                  path: '/details_index',
                  query: {
                    course_id: this.course_id,
                    share: this.share,
                    mission_id: data.mission.mission_id
                  }
                })
              }
            }

            this.type_obj = {
              nickname: data.user.nickname,
              train_name: data.info.name,
              train_id: data.info.id,
              share: data.user.id
            };
            shareCon("training", this, this.type_obj);
          });
      }
    },
    created() {
      this.pullData();
    }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bodys {
  // background-color: #2d1a44;
  text-align: center;
  padding-bottom: changeRem(2) + px
}

.top {
  width: 100%;
  // height: 600px;
  // background: url(../../../assets/top_b.png) top center;
  position: relative;
  span {
    position: absolute;
    right: 0;
    bottom: 32px;
    font-size: 24px;
    padding: 8px 26px 8px 16px;
    border-radius: 19px 0px 0px 19px;
    background-color: #eb5032;
    color: #ffffff;
    display: block;
  }
  img.top_m {
    width: 100%;
  }
  // .top_b {
  //   margin: 0 auto;
  //   bottom: 0;
  //   left: 30px;
  //   position: absolute;
  //   width: 690px;
  //   padding: 26px 30px;
  //   background: rgba(255, 255, 255, 1);
  //   border-radius: 8px;
  //   .tb_l {
  //     float: left;
  //     text-align: left;
  //     h2 {
  //       color: #333;
  //       font-size: 26px;
  //       line-height: 24px;
  //     }
  //     h3 {
  //       background: rgba(255, 255, 255, 1);
  //       border: 2px solid rgba(235, 80, 50, 1);
  //       padding: 2px 10px;
  //       font-size: 30px;
  //       color: #EB5032;
  //       margin-top: 10px;
  //       border-radius: 8px;
  //     }
  //     h4 {
  //       margin-top: 10px;
  //       color: #666;
  //       font-size: 24px;
  //       line-height: 22px;
  //     }
  //   }
  //   .tb_r {
  //     float: right;
  //     display: flex;
  //     .red-envelope{
  //       float: left;
  //       width: 90px;
  //       height: 116px;
  //       color: #ffffff;
  //       background: url('../../../assets/t_money.png') center no-repeat;
  //       background-size: 100% 100%;
  //       margin-right: 14px;
  //       position: relative;
  //       .red-envelope-text{
  //         position: absolute;
  //         left: 50%;
  //         transform: translateX(-50%);
  //         bottom: 18px;
  //         line-height: 1;
  //         color: #ffffff;
  //         font-size: 30px;
  //         .red-num{
  //           font-size: 50px;
  //           color: #ffffff;
  //           margin-right: 2px;
  //         }
  //       }
  //     }
  //     span {
  //       line-height: 35px;
  //       color: #EB5032;
  //       font-size: 30px;
  //       float: right;
  //       margin-top: 26px;
  //     }
  //   }
  // }
}

// .tar_img img {
//   width: 100%;
// }

// .tar_imgs img {
//   vertical-align: bottom;
// }
.top_v {
  padding: 14px 30px;
  color: #333;
  font-size: 32px;
  text-align: left;
  font-weight: bold;
  background-color: #f0f0f0;
  img {
    width: 70px;
    height: 70px;
    margin-right: 20px;
    border-radius: 50%;
  }
  .v_r {
    display: inline-block;
    width: 590px;
    float: right;
    h2 {
      color: #333;
      font-size: 32px;
      text-align: left;
      font-weight: bold;
    }
    h3 {
      color: #333;
      font-size: 26px;
    }
  }
}

.foot {
  height: 98px;
  font-size: 34px;
  position: fixed;
  bottom: 0;
  left: 50%;
  margin-left: -375px;
  width: 100%;
  max-width: 750px;
  line-height: 40px;
  text-align: center;
  .foot_l {
    display: block;
    width: 214px;
    background-color: #fff;
    float: left;
    color: #EB5032;
    height: 100%;
    padding-top: 10px;
  }
  .foot_r {
    width: 536px;
    background-color: #EB5032;
    float: right;
    color: #fff;
    height: 100%;
    padding-top: 12px;
  }
  a {
    width: 100%;
    height: 100%;
    display: block;
    color: #fff;
  }
}
.banq {
  font-size: 26px;
  // color: #fff;
  color: #333333;
  width: 100%;
  padding: 20px;
  text-align: justify;
  margin: 20px 0;
}
.content{
  position: relative;
  .on-money{
      display: block;
      width: 100%;
      padding: 0 134px;
      box-sizing: border-box;
      position: absolute;
      text-align: center;
      bottom: 84px;
      left: 50%;
      transform: translateX(-50%);
      font-size: 36px;
      color: #333333;
      span{
          color: #EB5032;
      }
  }
}
.learning-instructions {
  margin: 30px 26px 0;
  padding: 32px 50px 70px;
  background-color: #ffffff;
  h3 {
    display: block;
    margin: 0 auto;
    text-align: center;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 65px;
    background-color: #f5b417;
    color: #333333;
    border-radius: 8px 8px 0px 0px;
  }
  .instructions-content {
    padding: 30px 20px;
    p {
      text-align: left;
      font-size: 26px;
      color: #333333;
      line-height: 39px;
      margin-bottom: 20px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.tar_img{
  font-size: 0;
}
.tar_img img {
  width: 100%;
}
.tar_imgs img{
  vertical-align: middle;
}
</style>